import { defineStore } from 'pinia';
import { login, me} from '@/api/auth';
import { getDictionary } from '@/api/core';
import { useRouter } from 'vue-router';
import { useToast } from '@/components/ui/toast/use-toast'
import { useDictionaryStore } from '@/store/dictionary';
import { useSettingsStore } from '@/store/settings';
export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null as any,
    tokens: null as any,
    permissions: [],
    roles: [],
  }),
  actions: {
    async login(email: string, password: string) {
      await new Promise((resolve) => setTimeout(resolve, 1500));
      this.setTokens({ access: 'access_token', refresh: 'refresh_token' });
      this.setUser({
        id: 1,
        email: 'admin@robi.solutions',
        name: 'Admin',
        phone_number: '+79000000000',
        telegram_id: 1,
        roles: ['admin'],
        permissions: ['all'],
        is_active: true,
        is_verified: true
      });
      return true
      const response = await login(email, password);
      if (response.status === 200) {
        this.setTokens({ access: response.data.access_token, refresh: response.data.refresh_token });
        const responseMe = await me()
        if (responseMe.status === 200) {
          this.setUser(responseMe.data);
          this.roles = responseMe.data.roles;
          this.permissions = responseMe.data.permissions;
        }
        const dictionaryStore = useDictionaryStore();
        const settingsStore = useSettingsStore();
        await dictionaryStore.init();
        await settingsStore.init();
        // const router = useRouter();
        // router.push('/');
        return true;
      } else {
        const { toast } = useToast();
        toast({
          title: response.data?.message || 'Неверный email или пароль',
          variant: 'destructive'
        });
        return false;
      }
    },
    isAuthenticated() {
      const access_token = localStorage.getItem('access_token');
      const refresh_token = localStorage.getItem('refresh_token');
      return access_token !== null && refresh_token !== null;
    },
    setUser(user: any) {
      this.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    clearUser() {
      this.user = null;
      this.permissions = [];
      this.roles = [];
      localStorage.removeItem('user');
    },
    setTokens(tokens: { access: string, refresh: string }) {
      this.tokens = tokens;
      localStorage.setItem('access_token', tokens?.access);
      localStorage.setItem('refresh_token', tokens?.refresh);
    },
    clearTokens() {
      this.tokens = null;
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
    },
    async validateTokens() {
      console.log('validateTokens');
      const access_token = localStorage.getItem('access_token');
      const refresh_token = localStorage.getItem('refresh_token');
      if (!access_token || !refresh_token) {
        console.log('validateTokens: no tokens');
        this.setUser(null);
        this.clearTokens();
        return;
      }
      this.setTokens({ access: access_token, refresh: refresh_token });
      // const _me = await me()
      const _me = {
        status: 200,
        data: {
          id: 1,
          email: 'admin@robi.solutions',
          name: 'Admin',
          phone_number: '+79000000000',
          telegram_id: 1,
          roles: ['admin'],
          permissions: ['all'],
          is_active: true,
          is_verified: true
        }
      }
      const dictionaryStore = useDictionaryStore();
      const settingsStore = useSettingsStore();
      await dictionaryStore.init();
      await settingsStore.init();
      console.log('validateTokens: me', _me);
      if (_me.status === 200 && _me.data) {
        this.setUser(_me.data);
        this.roles = _me.data.roles;
        this.permissions = _me.data.permissions;
      } else {
        console.log('validateTokens: me failed');
        this.setUser(null);
        this.clearTokens();
      }
    },
  },
});
